export const THEME_DEFAULT = 'default';
// special theme for advanced exhibition content blocks
export const THEME_AEX = 'aex';
